import { useEffect, useState } from 'react';

export default function useAnimatedStatic(active) {
  const [position, setPosition] = useState('0px 0px');
  useEffect(() => {
    if (!active) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let animation;
    const update = () => {
      clearInterval(animation);
      if (!motion.matches) {
        animation = setInterval(() => {
          setPosition(
            `${Math.floor(Math.random() * 1920)}px ${Math.floor(
              Math.random() * 1080
            )}px`
          );
        }, 1000 / 16);
      }
    };
    update();
    motion.addEventListener('change', update);
    return () => {
      clearInterval(animation);
      motion.removeEventListener('change', update);
    };
  }, [active]);
  return position;
}
